export const __CONFIG_KEY__ = '__config__'
export const __ROOT_NODE__ = 'root'
export const __I18N_KEY__ = '__i18n__'

export const FALLBACK_DEFAULT_BDUI_FORM_VALUES = [
  {
    vertical_name: 'cargo',
    default_values: {
      offer_name: 'cargo',
      taxi_class: 'cargo',
      skip_confirmation: false,
    },
  },
  {
    vertical_name: 'express',
    default_values: {
      offer_name: 'express_d2d',
      taxi_class: 'express',
      skip_confirmation: false,
    },
  },
  {
    vertical_name: 'walking_courier',
    default_values: {
      offer_name: 'courier_walking',
      taxi_class: 'walking_courier',
    },
  },
  {
    vertical_name: 'ndd_self_pickup',
    default_values: {
      offer_name: 'ndd_self_pickup',
      taxi_class: 'ndd_self_pickup',
      skip_confirmation: false,
    },
  },
]
